import { useContext, useMemo } from 'react';

import { UserPreferencesContext } from '../userPreferenceContext';

export function useSkillTaxonomy(): number | undefined {
  const { preferences } = useContext(UserPreferencesContext);

  const selection = useMemo(() => {
    const taxonomies = preferences.taxonomies || {};
    const skillPref = taxonomies?.skill;
    const effectiveSkillPref = taxonomies?.effectiveSkillTaxonomySelection;

    if (!skillPref) return 0;

    if (skillPref === 'adaptive') {
      // When adaptive, use the effective selection if available (computed
      // by adaptive taxonomy hooks). Return undefined while unresolved so
      // callers that can handle it (like useCustomSkillTaxonomyTree) can
      // decide whether to pause or fall back to default.
      if (typeof effectiveSkillPref === 'number' && effectiveSkillPref > 0) {
        return effectiveSkillPref;
      }
      return undefined;
    }

    if (typeof skillPref === 'number') return skillPref;
    return 0;
  }, [preferences]);

  return selection;
}
